<template>
    <v-switch v-bind="$attrs" v-model="localValue" xclass="px-2 py-0 ma-0" :dense="dense">
        <template v-slot:label>
            <div class="text-caption">{{ label }}</div>
        </template>
    </v-switch>
</template>

<script>
export default {
    props: {
        value: null,
        label: null,
        dense: Boolean,
    },
    data() {
        return {
            localValue: '',
        };
    },
    updated() {
        this.localValue = this.value;
    },
    mounted() {
        this.localValue = this.value ? true : null;
    },
    watch: {
        localValue() {
            this.$emit('input', this.localValue ? true : false);
        },
    },
};
</script>
